import QuizGenerator from './quiz-generator';
import Source from './source';
import RegExpPresets from './constants/regexp-presets';

export default QuizGenerator;
export {
  Source,
  RegExpPresets,
};
